import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageNWSL3 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "USWNT in 2026 SheBelieves Cup",
            author: "footballgirl",
              date: "January, 2026",
            image: "images/nwsl/3a.jpg",
            content: `<h2>USWNT to Face Canada, Colombia, and Argentina in 2026 SheBelieves Cup</h2>

<h2>Introduction</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
<p>The United States Women's National Team (<strong>USWNT</strong>)
 is gearing up for the 11th edition of the SheBelieves Cup, 
 an annual invitational tournament
  presented by Visa and hosted in the United States. </p>
  
  <p>Set to run from March 1 to March 7, 2026, 
  the event features four competitive teams: the host USWNT 
  (ranked No. 2 in the FIFA Women's World Rankings as of December 2025), 
  Canada (No. 6), Colombia (No. 22), and Argentina (No. 30).</p>
  
  <p>This round-robin 
  format provides the USWNT, under head coach Emma Hayes, an opportunity
   to build momentum toward the 2027 FIFA Women's World Cup qualifiers. 
   The Americans aim to reclaim the title after losing it in the 2025 edition, 
   following five consecutive wins from 2020 to 2024.</p>

<h2>Tournament Schedule</h2>
<p>The 2026 SheBelieves Cup will be played across three venues in a doubleheader format, with each team facing the others once. The winner is determined by the team with the most points at the end of the round-robin stage. All times are Eastern unless otherwise noted:</p>
<p><strong>Sunday, March 1</strong> at GEODIS Park, Nashville, Tennessee:<br>
Canada vs. Colombia (2:00 p.m. ET)<br>
United States vs. Argentina (5:00 p.m. ET)</p>
<p><strong>Wednesday, March 4</strong> at ScottsMiracle-Gro Field, Columbus, Ohio:<br>
Argentina vs. Colombia (3:30 p.m. ET)<br>
United States vs. Canada (6:45 p.m. ET)</p>
<p><strong>Saturday, March 7</strong> at Sports Illustrated Stadium, Harrison, New Jersey:<br>
Canada vs. Argentina (12:30 p.m. ET)<br>
United States vs. Colombia (3:30 p.m. ET)</p>
<p>The final matchday in New Jersey will include a pregame ceremony honoring the retirement of USWNT legend Tobin Heath, a New Jersey native and key contributor to multiple World Cup and Olympic victories.</p>

<h2>USWNT Overview</h2>
<p>Head coach Emma Hayes has selected a 26-player roster blending experience with youth, focusing on depth amid preparations for World Cup qualifiers. Recent adjustments include defender Emily Sams replacing the injured Jordyn Bugg and Avery Patterson stepping in for Kate Wiesner. Notable absences include forwards Mallory Swanson and Sophia Smith (due to recent childbirths) and midfielder Catarina Macario (injury recovery). Key veterans like Lindsey Horan, Rose Lavelle, and Naomi Girma anchor the squad, while emerging talents such as Jaedyn Shaw, Trinity Rodman, and Olivia Moultrie add dynamism. The USWNT's roster by position includes:</p>
<p><strong>Goalkeepers (3):</strong> Claudia Dickey
 (Seattle Reign FC), Mandy McGlynn (Utah Royals), Phallon Tullis-Joyce (Manchester United).</p>
<p><strong>Defenders (9):</strong> Emily Sams 
(Orlando Pride / Angel City FC in some listings),
 Emily Fox (Arsenal), Naomi Girma (Chelsea), Lilly Reale (Gotham FC),
  Tara Rudd (Washington Spirit), Emily Sonnett (Gotham FC), 
  Gisele Thompson (Angel City FC), Kennedy Wesley (San Diego Wave FC), Avery Patterson (Houston Dash).</p>
<p><strong>Midfielders (8):</strong> Sam Coffey (Manchester City), Lindsey Horan (OL Lyon), Claire Hutton (Bay FC), Riley Jackson (North Carolina Courage), Rose Lavelle (Gotham FC), Olivia Moultrie (Portland Thorns FC), Jaedyn Shaw (Gotham FC), Lily Yohannes (OL Lyon).</p>
<p><strong>Forwards (6):</strong> Maddie Dahlien (Seattle Reign FC), Jameese Joseph (Chicago Red Stars), Trinity Rodman (Washington Spirit), Alyssa Thompson (Angel City FC / Chelsea in some listings), Ally Sentnor (Utah Royals / Kansas City Current in some listings), Emma Sears (Racing Louisville FC).</p>
<p>This mix emphasizes tactical flexibility and high pressing, with Hayes prioritizing roster stability ahead of November's Concacaf W Championship.</p>

<h2>Opponent Profiles</h2>

<h3>Canada</h3>
<p>Canada, ranked No. 6 in the world, enters their fourth SheBelieves Cup under new head coach Casey Stoney.
 The team focuses on rebuilding after a transitional 2025, with World 
 Cup qualification as the top priority. Their 24-player 
 roster features a blend of international stars and domestic talent,
  but several key players like Ashley Lawrence and Adriana Leon were 
  not selected.</p> <p>Returning players include Cloé Lacasse (after injury) 
  and new call-up Brooklyn Courtnall. Goalkeeper Kailen Sheridan leads 
  the backline, with midfield creativity from Jessie Fleming 
  (Portland Thorns FC) and forwards like Jordyn Huitema posing threats.
   Canada emphasizes defensive solidity and quick transitions.</p>

<h3>Colombia</h3>
<p>Colombia, ranked No. 22, makes their second SheBelieves Cup appearance
 after participating in 2025, where they secured one win in three matches.
  Known for individual talent and physicality, Las Cafeteras have shown growth,
   reaching the quarterfinals of the 2023 FIFA Women's World Cup.</p>
   <p> Key players include midfielder Leicy Santos (Washington Spirit), 
    forward Mayra Ramírez (Chelsea), and winger Linda Caicedo (Real Madrid), 
    who bring speed and flair.</p>
     <p>Colombia's style emphasizes counterattacks and set-piece prowess,
      making them a dangerous 
      underdog as they build toward future competitions.</p>

<h3>Argentina</h3>
<p>Argentina, ranked No. 30, returns to the SheBelieves Cup for the 
second time since 2021, when they finished fourth. La Albiceleste,
 under head coach Germán Portanova, features a compact roster drawn from 
 domestic and European leagues.</p>
 <p>Standouts include defenders Sophia Braun and Eliana Stábile,
   midfielders Daiana Falfán and Catalina Ongaro, and 
   forwards Carolina Troncoso and young prospect Milagros Martín.</p>
   
   <p>Argentina's approach relies on organized defending and quick breaks, 
   seeking experience against top competition despite a 
   challenging historical record against the USWNT.</p>

<h2>Broadcast Information</h2>
<p>U.S. matches will be broadcast in English on TNT, truTV, and TBS,
 with Spanish-language coverage on Universo and Telemundo. 
 Streaming options include HBO Max and Peacock, ensuring wide 
 accessibility for fans.</p>

<h2>Conclusion</h2>
<p>The 2026 SheBelieves Cup promises intense competition as the USWNT faces familiar North American rival Canada and rising South American sides Colombia and Argentina. With World Cup qualifiers on the horizon, this tournament serves as a critical benchmark for team development and tactical refinement. As the USWNT seeks an eighth title, the event highlights the growing parity in women's soccer globally.</p>
<p>Here are three questions for readers to ponder:</p>
<p>1. How will the USWNT's youthful forwards compensate for the absences of key veterans like Swanson and Smith?<br>
<p>2. Can Canada overcome their roster adjustments to challenge
 for the tournament title?<br>
<p>3. Which underdog—Colombia or Argentina—has the best chance of 
pulling off an upset?</p> <h1>美国女足将在2026年SheBelieves杯面对加拿大、哥伦比亚和阿根廷</h1>

<h2>引言</h2>
<p>美国女子国家足球队（<strong>USWNT</strong>）正准备参加第11届SheBelieves杯，这是一项由Visa赞助、在美国举办的年度邀请赛。从2026年3月1日至3月7日，该赛事将有四支球队参赛：东道主USWNT（截至2025年12月FIFA女子世界排名第2）、加拿大（第6）、哥伦比亚（第22）和阿根廷（第30）。采用循环赛制，这为USWNT主教练埃玛·海耶斯（Emma Hayes）提供了在2027年FIFA女子世界杯预选赛前积累势头的机会。美国队希望在2025年丢冠后重新夺回冠军，此前从2020年至2024年连续五次夺冠。</p>

<h2>赛事赛程</h2>
<p>2026年SheBelieves杯将在三个场地进行双场比赛，每支球队与其他球队各交手一次。获胜者由循环赛结束时积分最高的球队决定。所有时间均为东部时间（ET），除非另有注明：</p>
<p><strong>3月1日星期日</strong> 在田纳西州纳什维尔GEODIS Park：<br>
加拿大 vs. 哥伦比亚 (2:00 p.m. ET)<br>
美国 vs. 阿根廷 (5:00 p.m. ET)</p>
<p><strong>3月4日星期三</strong> 在俄亥俄州哥伦布ScottsMiracle-Gro Field：<br>
阿根廷 vs. 哥伦比亚 (3:30 p.m. ET)<br>
美国 vs. 加拿大 (6:45 p.m. ET)</p>
<p><strong>3月7日星期六</strong> 在新泽西州哈里森Sports Illustrated Stadium：<br>
加拿大 vs. 阿根廷 (12:30 p.m. ET)<br>
美国 vs. 哥伦比亚 (3:30 p.m. ET)</p>
<p>新泽西的决赛日将包括赛前仪式，表彰美国女足传奇人物托宾·希思（Tobin Heath）的退役，她是新泽西本地人，曾为美国队赢得多次世界杯和奥运冠军。</p>

<h2>美国女足概览</h2>
<p>主教练埃玛·海耶斯选出了26人阵容，融合经验与年轻球员，注重深度以备战世界杯预选赛。最近调整包括后卫艾米丽·萨姆斯（Emily Sams）替换受伤的乔丹·巴格（Jordyn Bugg），以及艾弗里·帕特森（Avery Patterson）替换凯特·威斯纳（Kate Wiesner）。值得注意的缺席包括前锋马洛里·斯旺森（Mallory Swanson）和索菲娅·史密斯（Sophia Smith）因近期生育，以及中场卡塔里娜·马卡里奥（Catarina Macario）因伤恢复。关键老将如林赛·霍兰（Lindsey Horan）、罗斯·拉维尔（Rose Lavelle）和娜奥米·吉尔玛（Naomi Girma）坐镇阵容，新秀如杰丁·肖（Jaedyn Shaw）、特里尼蒂·罗德曼（Trinity Rodman）和奥利维娅·穆尔特里（Olivia Moultrie）增添活力。美国女足按位置阵容包括：</p>
<p><strong>门将 (3)：</strong> 克劳迪娅·迪基（Claudia Dickey，Seattle Reign FC）、曼迪·麦格林（Mandy McGlynn，Utah Royals）、法隆·图利斯-乔伊斯（Phallon Tullis-Joyce，Manchester United）。</p>
<p><strong>后卫 (9)：</strong> 艾米丽·萨姆斯（Emily Sams，Orlando Pride）、艾米丽·福克斯（Emily Fox，Arsenal）、娜奥米·吉尔玛（Naomi Girma，Chelsea）、莉莉·里尔（Lilly Reale，Gotham FC）、塔拉·鲁德（Tara Rudd，Washington Spirit）、艾米丽·桑内特（Emily Sonnett，Gotham FC）、吉塞尔·汤普森（Gisele Thompson，Angel City FC）、肯尼迪·韦斯利（Kennedy Wesley，San Diego Wave FC）、艾弗里·帕特森（Avery Patterson，Houston Dash）。</p>
<p><strong>中场 (8)：</strong> 萨姆·科菲（Sam Coffey，Manchester City）、林赛·霍兰（Lindsey Horan，OL Lyon）、克莱尔·赫顿（Claire Hutton，Bay FC）、莱莉·杰克逊（Riley Jackson，North Carolina Courage）、罗斯·拉维尔（Rose Lavelle，Gotham FC）、奥利维娅·穆尔特里（Olivia Moultrie，Portland Thorns FC）、杰丁·肖（Jaedyn Shaw，Gotham FC）、莉莉·约翰内斯（Lily Yohannes，OL Lyon）。</p>
<p><strong>前锋 (6)：</strong> 麦迪·达利恩（Maddie Dahlien，Seattle Reign FC）、贾米斯·约瑟夫（Jameese Joseph，Chicago Red Stars）、特里尼蒂·罗德曼（Trinity Rodman，Washington Spirit）、阿莉莎·汤普森（Alyssa Thompson，Angel City FC）、阿莉·森特诺（Ally Sentnor，Utah Royals）、艾玛·西尔斯（Emma Sears，Racing Louisville FC）。</p>
<p>这一组合强调战术灵活性和高位逼抢，海耶斯优先考虑阵容稳定性，以备战11月的Concacaf女子锦标赛。</p>

<h2>对手简介</h2>

<h3>加拿大</h3>
<p>加拿大队世界排名第6，这是她们第四次参加SheBelieves杯，在新主教练凯西·斯托尼（Casey Stoney）带领下重建球队。重点是世界杯资格赛。24人阵容融合国际球星和本土人才，但多名关键球员如阿什莉·劳伦斯（Ashley Lawrence）和阿德里安娜·莱昂（Adriana Leon）未入选。回归球员包括伤愈的克洛伊·拉卡斯（Cloé Lacasse）。门将凯伦·谢里丹（Kailen Sheridan，North Carolina Courage）领衔后防，中场由杰西·弗莱明（Jessie Fleming，Portland Thorns FC）提供创造力，前锋如乔丹·惠特马（Jordyn Huitema）构成威胁。加拿大强调防守稳固和快速转换。</p>

<h3>哥伦比亚</h3>
<p>哥伦比亚队排名第22，这是她们继2025年后第二次参加SheBelieves杯，当时三场比赛取得一胜。以个人天赋和身体对抗著称，Las Cafeteras在2023年女足世界杯进入八强。关键球员包括中场莱西·桑托斯（Leicy Santos，Washington Spirit）、前锋迈拉·拉米雷斯（Mayra Ramírez，Chelsea）和边锋琳达·凯塞多（Linda Caicedo，Real Madrid），带来速度和创造力。哥伦比亚风格强调反击和定位球，是危险的黑马。</p>

<h3>阿根廷</h3>
<p>阿根廷队排名第30，这是她们自2021年（当时第四）后第二次参加SheBelieves杯。在主教练赫尔曼·波尔塔诺瓦（Germán Portanova）带领下，阵容紧凑，来自本土和欧洲联赛。亮点球员包括后卫索菲娅·布劳恩（Sophia Braun）和埃利亚娜·斯塔比莱（Eliana Stábile）、中场黛安娜·法尔凡（Daiana Falfán）和卡塔利娜·翁加罗（Catalina Ongaro）、前锋卡罗琳娜·特隆科索（Carolina Troncoso）和年轻天才米拉格罗斯·马丁（Milagros Martín）。阿根廷依赖有组织防守和快速反击，尽管对阵美国队历史战绩不佳，仍希望从顶级对手身上积累经验。</p>

<h2>转播信息</h2>
<p>美国比赛将在英语频道TNT、truTV和TBS播出，西班牙语覆盖由Universo和Telemundo提供。流媒体选项包括HBO Max和Peacock，确保球迷广泛观看。</p>

<h2>结语</h2>
<p>2026年SheBelieves杯将带来激烈竞争，美国女足将面对熟悉的北美对手加拿大以及崛起的南美球队哥伦比亚和阿根廷。随着世界杯预选赛临近，本届赛事是球队发展和战术完善的关键基准。美国女足寻求第八次夺冠，同时凸显女子足球全球竞争力的日益均衡。</p>
<p>留给读者思考的三个问题：</p>
<p>1. 美国女足的年轻前锋如何弥补斯旺森和史密斯等关键老将的缺席？<br>
2. 加拿大能否克服阵容调整，挑战赛事冠军？<br>
3. 哪支黑马——哥伦比亚还是阿根廷——更有机会爆冷取胜？</p>`,
                       tags: ["NWSL", "canada", "colombia", "argentina", "USWNT", "sheBelieves"],

navIndices: { prev: 'nwsl-2', next: 'nwsl-4' }
        });
    }

    init() {
        console.log('ArticlePageNWSL3 initialized');
        super.init();
    }

    render() {
        super.render();
        
        // Update Back Button Text and Behavior
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to NWSL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'nwsl' } });
                this.element.dispatchEvent(event);
            });
        }

        // Update League Logo
        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_nwsl.png';
            leagueLogo.alt = 'NWSL';
        }
    }
}